class ClientIdentifier {
    public static fileNumberMatchSeriePrefix(fileNumber: string): boolean {
        if (IsNullOrWhiteSpace(fileNumber))
            return false;

        if (IsNullOrWhiteSpace(ClientIdentifier.getFileNumberPrefix()))
            return true;

        return fileNumber.substring(0, 1).toUpperCase() == ClientIdentifier.getFileNumberPrefix();
    }

    public static getFileNumberPrefix(): string {
        if (ClientIdentifier.IsCsssiugs)
            return "P";
        if (ClientIdentifier.IsHerzl)
            return "U";
        if (ClientIdentifier.isCscp)
            return "M";

        return "";
    }

    public static get IsCemtl(): boolean {
        return ["cemtl", "cemtl-test"].contains(cacheStore.GetClientIdentifier().toLowerCase());
    }

    public static get IsCsssiugs(): boolean {
        return ["csssiugs"].contains(cacheStore.GetClientIdentifier().toLowerCase());
    }

    public static get IsHerzl(): boolean {
        return ["herzl", "herzltest"].contains(cacheStore.GetClientIdentifier().toLowerCase());
    }

    public static get IsGmfUMR(): boolean {
        return ["gmfumr", "gmfumrtest"].contains(cacheStore.GetClientIdentifier().toLowerCase());
    }

    public static get IsBSL(): boolean {
        return [].contains(cacheStore.GetClientIdentifier().toLowerCase());
    }

    public static get isCscp(): boolean {
        return ["cscp"].contains(cacheStore.GetClientIdentifier().toLowerCase());
    }
}

export { ClientIdentifier };
